


























import Vue from 'vue';

export default Vue.extend({
  name: 'CookieBanner',
  data(): {
    isShow: boolean;
  } {
    return {
      isShow: this.$store.state.user.isCookieBannerShow,
    };
  },
  computed: {
    expiryTime(): string {
      // The cookie will expiry in ten years, since cannot set a lifetime cookie
      const expiry = new Date();
      expiry.setTime(expiry.getTime() + (3650 * 24 * 60 * 60 * 1000));

      return expiry.toUTCString();
    },
    isCookieSet(): boolean{
      return !!localStorage.getItem("cookiePolicy");
    },
    isShowCookiePolicy(): boolean {
      return !this.isCookieSet && this.isShow;
    },
  },
  methods: {
    async all() {
      window.localStorage.setItem("cookiePolicy", "all");
      await this.$store.dispatch('setIsCookieBannerShow', false);
      this.isShow = false;
    },
    async requiredOnly() {
      window.localStorage.setItem("cookiePolicy", "requiredOnly");
      await this.$store.dispatch('setIsCookieBannerShow', false);
      this.isShow = false;
    },
  },
  watch: {
    '$store.state.user.isCookieBannerShow': function() {
      this.isShow = this.$store.state.user.isCookieBannerShow
    }
  }
});
